export const countries = [
  {
    value: "1",
    label: "Австралия",
  },
  {
    value: "2",
    label: "Австрия",
  },
  {
    value: "3",
    label: "Азербайджан",
  },
  {
    value: "4",
    label: "Албания",
  },
  {
    value: "5",
    label: "Алжир",
  },
  {
    value: "6",
    label: "Ангола",
  },
  {
    value: "7",
    label: "Андорра",
  },
  {
    value: "8",
    label: "Антигуа и Барбуда",
  },
  {
    value: "9",
    label: "Аргентина",
  },
  {
    value: "10",
    label: "Армения",
  },
  {
    value: "11",
    label: "Афганистан",
  },
  {
    value: "12",
    label: "Багамские Острова",
  },
  {
    value: "13",
    label: "Бангладеш",
  },
  {
    value: "14",
    label: "Барбадос",
  },
  {
    value: "15",
    label: "Бахрейн",
  },
  {
    value: "17",
    label: "Белиз",
  },
  {
    value: "16",
    label: "Белоруссия",
  },
  {
    value: "18",
    label: "Бельгия",
  },
  {
    value: "19",
    label: "Бенин",
  },
  {
    value: "20",
    label: "Болгария",
  },
  {
    value: "21",
    label: "Боливия",
  },
  {
    value: "22",
    label: "Босния и Герцеговина",
  },
  {
    value: "23",
    label: "Ботсвана",
  },
  {
    value: "24",
    label: "Бразилия",
  },
  {
    value: "25",
    label: "Бруней",
  },
  {
    value: "26",
    label: "Буркина-Фасо",
  },
  {
    value: "27",
    label: "Бурунди",
  },
  {
    value: "28",
    label: "Бутан",
  },
  {
    value: "29",
    label: "Вануату",
  },
  {
    value: "30",
    label: "Великобритания",
  },
  {
    value: "31",
    label: "Венгрия",
  },
  {
    value: "32",
    label: "Венесуэла",
  },
  {
    value: "33",
    label: "Восточный Тимор",
  },
  {
    value: "34",
    label: "Вьетнам",
  },
  {
    value: "35",
    label: "Габон",
  },
  {
    value: "36",
    label: "Гаити",
  },
  {
    value: "37",
    label: "Гайана",
  },
  {
    value: "38",
    label: "Гамбия",
  },
  {
    value: "39",
    label: "Гана",
  },
  {
    value: "40",
    label: "Гватемала",
  },
  {
    value: "41",
    label: "Гвинея",
  },
  {
    value: "42",
    label: "Гвинея-Бисау",
  },
  {
    value: "43",
    label: "Германия",
  },
  {
    value: "44",
    label: "Гондурас",
  },
  {
    value: "45",
    label: "Гренада",
  },
  {
    value: "46",
    label: "Греция",
  },
  {
    value: "47",
    label: "Грузия",
  },
  {
    value: "48",
    label: "Дания",
  },
  {
    value: "80",
    label: "Демократическая Республика Конго",
  },
  {
    value: "49",
    label: "Джибути",
  },
  {
    value: "50",
    label: "Доминика",
  },
  {
    value: "51",
    label: "Доминиканская Республика",
  },
  {
    value: "52",
    label: "Египет",
  },
  {
    value: "53",
    label: "Замбия",
  },
  {
    value: "54",
    label: "Зимбабве",
  },
  {
    value: "55",
    label: "Израиль",
  },
  {
    value: "56",
    label: "Индия",
  },
  {
    value: "57",
    label: "Индонезия",
  },
  {
    value: "58",
    label: "Иордания",
  },
  {
    value: "59",
    label: "Ирак",
  },
  {
    value: "60",
    label: "Иран",
  },
  {
    value: "61",
    label: "Ирландия",
  },
  {
    value: "62",
    label: "Исландия",
  },
  {
    value: "63",
    label: "Испания",
  },
  {
    value: "64",
    label: "Италия",
  },
  {
    value: "65",
    label: "Йемен",
  },
  {
    value: "66",
    label: "Кабо-Верде",
  },
  {
    value: "67",
    label: "Казахстан",
  },
  {
    value: "68",
    label: "Камбоджа",
  },
  {
    value: "69",
    label: "Камерун",
  },
  {
    value: "70",
    label: "Канада",
  },
  {
    value: "71",
    label: "Катар",
  },
  {
    value: "72",
    label: "Кения",
  },
  {
    value: "73",
    label: "Кипр",
  },
  {
    value: "74",
    label: "Киргизия",
  },
  {
    value: "75",
    label: "Кирибати",
  },
  {
    value: "76",
    label: "Китай",
  },
  {
    value: "81",
    label: "КНДР",
  },
  {
    value: "77",
    label: "Колумбия",
  },
  {
    value: "78",
    label: "Коморы",
  },
  {
    value: "83",
    label: "Коста-Рика",
  },
  {
    value: "84",
    label: "Кот-дИвуар",
  },
  {
    value: "85",
    label: "Куба",
  },
  {
    value: "86",
    label: "Кувейт",
  },
  {
    value: "87",
    label: "Лаос",
  },
  {
    value: "88",
    label: "Латвия",
  },
  {
    value: "89",
    label: "Лесото",
  },
  {
    value: "90",
    label: "Либерия",
  },
  {
    value: "91",
    label: "Ливан",
  },
  {
    value: "92",
    label: "Ливия",
  },
  {
    value: "93",
    label: "Литва",
  },
  {
    value: "94",
    label: "Лихтенштейн",
  },
  {
    value: "95",
    label: "Люксембург",
  },
  {
    value: "96",
    label: "Маврикий",
  },
  {
    value: "97",
    label: "Мавритания",
  },
  {
    value: "98",
    label: "Мадагаскар",
  },
  {
    value: "99",
    label: "Малави",
  },
  {
    value: "100",
    label: "Малайзия",
  },
  {
    value: "101",
    label: "Мали",
  },
  {
    value: "102",
    label: "Мальдивы",
  },
  {
    value: "103",
    label: "Мальта",
  },
  {
    value: "104",
    label: "Марокко",
  },
  {
    value: "105",
    label: "Маршалловы Острова",
  },
  {
    value: "106",
    label: "Мексика",
  },
  {
    value: "107",
    label: "Мозамбик",
  },
  {
    value: "108",
    label: "Молдавия",
  },
  {
    value: "109",
    label: "Монако",
  },
  {
    value: "110",
    label: "Монголия",
  },
  {
    value: "111",
    label: "Мьянма",
  },
  {
    value: "112",
    label: "Намибия",
  },
  {
    value: "113",
    label: "Науру",
  },
  {
    value: "114",
    label: "Непал",
  },
  {
    value: "115",
    label: "Нигер",
  },
  {
    value: "116",
    label: "Нигерия",
  },
  {
    value: "117",
    label: "Нидерланды",
  },
  {
    value: "118",
    label: "Никарагуа",
  },
  {
    value: "119",
    label: "Новая Зеландия",
  },
  {
    value: "120",
    label: "Норвегия",
  },
  {
    value: "121",
    label: "ОАЭ",
  },
  {
    value: "122",
    label: "Оман",
  },
  {
    value: "123",
    label: "Пакистан",
  },
  {
    value: "124",
    label: "Палау",
  },
  {
    value: "125",
    label: "Панама",
  },
  {
    value: "126",
    label: "Папуа",
  },
  {
    value: "127",
    label: "Парагвай",
  },
  {
    value: "128",
    label: "Перу",
  },
  {
    value: "129",
    label: "Польша",
  },
  {
    value: "130",
    label: "Португалия",
  },
  {
    value: "79",
    label: "Республика Конго",
  },
  {
    value: "82",
    label: "Республика Корея",
  },
  {
    value: "131",
    label: "Россия",
  },
  {
    value: "132",
    label: "Руанда",
  },
  {
    value: "133",
    label: "Румыния",
  },
  {
    value: "134",
    label: "Сальвадор",
  },
  {
    value: "135",
    label: "Самоа",
  },
  {
    value: "136",
    label: "Сан-Марино",
  },
  {
    value: "137",
    label: "Сан-Томе и Принсипи",
  },
  {
    value: "138",
    label: "Саудовская Аравия",
  },
  {
    value: "139",
    label: "Северная Македония",
  },
  {
    value: "140",
    label: "Сейшельские Острова",
  },
  {
    value: "141",
    label: "Сенегал",
  },
  {
    value: "142",
    label: "Сент-Винсент и Гренадины",
  },
  {
    value: "143",
    label: "Сент-Китс и Невис",
  },
  {
    value: "144",
    label: "Сент-Люсия",
  },
  {
    value: "145",
    label: "Сербия",
  },
  {
    value: "146",
    label: "Сингапур",
  },
  {
    value: "147",
    label: "Сирия",
  },
  {
    value: "148",
    label: "Словакия",
  },
  {
    value: "149",
    label: "Словения",
  },
  {
    value: "151",
    label: "Соломоновы Острова",
  },
  {
    value: "152",
    label: "Сомали",
  },
  {
    value: "153",
    label: "Судан",
  },
  {
    value: "154",
    label: "Суринам",
  },
  {
    value: "150",
    label: "США",
  },
  {
    value: "155",
    label: "Сьерра-Леоне",
  },
  {
    value: "156",
    label: "Таджикистан",
  },
  {
    value: "157",
    label: "Таиланд",
  },
  {
    value: "158",
    label: "Танзания",
  },
  {
    value: "159",
    label: "Того",
  },
  {
    value: "160",
    label: "Тонга",
  },
  {
    value: "161",
    label: "Тринидад и Тобаго",
  },
  {
    value: "162",
    label: "Тувалу",
  },
  {
    value: "163",
    label: "Тунис",
  },
  {
    value: "164",
    label: "Туркмения",
  },
  {
    value: "165",
    label: "Турция",
  },
  {
    value: "166",
    label: "Уганда",
  },
  {
    value: "167",
    label: "Узбекистан",
  },
  {
    value: "168",
    label: "Украина",
  },
  {
    value: "169",
    label: "Уругвай",
  },
  {
    value: "170",
    label: "Федеративные Штаты Микронезии",
  },
  {
    value: "171",
    label: "Фиджи",
  },
  {
    value: "172",
    label: "Филиппины",
  },
  {
    value: "173",
    label: "Финляндия",
  },
  {
    value: "174",
    label: "Франция",
  },
  {
    value: "175",
    label: "Хорватия",
  },
  {
    value: "176",
    label: "Центральноафриканская Республика",
  },
  {
    value: "177",
    label: "Чад",
  },
  {
    value: "178",
    label: "Черногория",
  },
  {
    value: "179",
    label: "Чехия",
  },
  {
    value: "180",
    label: "Чили",
  },
  {
    value: "181",
    label: "Швейцария",
  },
  {
    value: "182",
    label: "Швеция",
  },
  {
    value: "183",
    label: "Шри-Ланка",
  },
  {
    value: "184",
    label: "Эквадор",
  },
  {
    value: "185",
    label: "Экваториальная Гвинея",
  },
  {
    value: "186",
    label: "Эритрея",
  },
  {
    value: "187",
    label: "Эсватини",
  },
  {
    value: "188",
    label: "Эстония",
  },
  {
    value: "189",
    label: "Эфиопия",
  },
  {
    value: "190",
    label: "ЮАР",
  },
  {
    value: "191",
    label: "Южный Судан",
  },
  {
    value: "192",
    label: "Ямайка",
  },
  {
    value: "193",
    label: "Япония",
  },
];
